import styled from 'styled-components'

import { Box, Button, TransparentButton } from '@redriverpress/system'

export const RichButtonGroup = styled(Box)`
  display: flex;
  button {
    &:not(:first-child),
    &:not(:last-child) {
      border-right: none;
      border-radius: 0;
    }

    &:last-child {
      border: 2px solid ${props => props.theme.colors.black};
    }

    &:first-child {
      border-radius: 4px 0 0 4px;
    }
    &:last-child {
      border-radius: 0 4px 4px 0;
    }
  }
`

export const RichButton = styled(Button).attrs({
  px: '0.6rem',
  py: '0.2rem',
  fontSize: '0.6rem',
})`
  box-shadow: none;
  border: 2px solid ${props => props.theme.colors.black};

  &:hover {
    box-shadow: none;
    background-color: ${props => props.theme.colors.blue200};
  }

  &:focus {
    box-shadow: unset;
    border: 2px solid ${props => props.theme.colors.blue700};
  }
`

export const RichDropdownButton = styled(RichButton)`
  display: flex;
  align-items: center;
`

export const RichDropdownOptionsWrapper = styled(Box).attrs({
  display: 'flex',
  flexDirection: 'column',
  borderRadius: 'rounded',
  p: 1,
  bg: 'white',
  mt: 1,
  boxShadow: 1,
})``

export const RichDropdownOption = styled(TransparentButton)`
  text-align: left;
  font-size: 0.8rem;
  &:hover {
    background-color: ${props => props.theme.colors.blue500};
    color: ${props => props.theme.colors.white};
  }
`

export const RichColorDropdownHover = styled(Box)`
  background-color: transparent;
  border: solid 1px ${props => props.borderColor};
  width: 20px;
  height: 20px;
  position: absolute;
  padding: 12px;
  border-radius: 50%;
  z-index: 1;
  opacity: 0;

  &:hover {
    opacity: 1;
  }
`
